import styled from 'styled-components'
import { media } from '../../../layouts/utils'
import {
    borderRadius,
    colorBrandPrimary,
    colorNeutral,
    colorNeutralDark,
    fontFamily,
    shadow,
} from '../../../global.style'

export const ContainerImagemVazada = styled.div`
    min-height: 290px;
    max-width: 420px;
    display: flex;
    flex-direction: column;
    background-color: ${colorNeutral.light};
    border-radius: ${borderRadius.md};
    box-sizing: border-box;
    box-shadow: ${shadow.level1};
    padding: 30px 29px;
    align-items: flex-start;
    &:hover {
        box-shadow: ${shadow.level2};
    }
`
export const ImagemVazada = styled.img`
    margin-top: -140px;
    height: 221px;
    width: 221px;
    border-radius: 50%;
    object-fit: cover;
    margin-bottom: 20px;
    align-self: center;

    ${media.large`
        margin-top: -150px;
        margin-bottom: 24px;
    `}
`
export const CardTitulo = styled.span`
    color: ${colorBrandPrimary.marine};
    font-family: ${fontFamily.brand};
    font-size: 24px;
    letter-spacing: 0;
    line-height: 31.2px;
    min-height: 24px;
    align-self: ${({ alinhamento }) =>
        alinhamento === 'Centro'
            ? `center`
            : alinhamento === 'Fim'
            ? `end`
            : `start`};
    text-align: ${(alinhamento) =>
        alinhamento === 'Centro'
            ? `center`
            : alinhamento === 'Fim'
            ? `end`
            : `start`};
    code {
        align-self: center;
        text-align: center;
        font-family: ${fontFamily.neutral};
        font-size: 14px;
        line-height: 21px;
    }

    p {
        margin-bottom: 13px;
        color: ${colorNeutralDark['90']};
        align-self: ${({ alinhamento }) =>
            alinhamento === 'Centro'
                ? `center`
                : alinhamento === 'Fim'
                ? `end`
                : `start`};
        text-align: ${({ alinhamento }) =>
            alinhamento === 'Centro'
                ? `center`
                : alinhamento === 'Fim'
                ? `end`
                : `start`};
    }
    h2 {
        font-family: ${fontFamily.brand};
        font-size: 24px;
        line-height: 26px;
        font-weight: normal;
        padding-bottom: 13px;
        align-self: ${({ alinhamento }) =>
            alinhamento === 'Centro'
                ? `center`
                : alinhamento === 'Fim'
                ? `end`
                : `start`};
        text-align: ${({ alinhamento }) =>
            alinhamento === 'Centro'
                ? `center`
                : alinhamento === 'Fim'
                ? `end`
                : `start`};
    }

    ${media.large`
        font-size: 20px;
        line-height: 24px;
        margin-bottom: 14px;
    `}
`
export const CardTexto = styled.span`
    color: ${colorBrandPrimary.marine};
    font-family: ${fontFamily.neutral};
    font-size: 16px;
    letter-spacing: 0;
    line-height: 24px;
    align-items: center;
    display: flex;
    flex-direction: column;
    align-self: ${({ alinhamento }) =>
        alinhamento === 'Centro'
            ? `center`
            : alinhamento === 'Fim'
            ? `end`
            : `start`};
    text-align: ${(alinhamento) =>
        alinhamento === 'Centro'
            ? `center`
            : alinhamento === 'Fim'
            ? `end`
            : `start`};

    code {
        align-self: center;
        text-align: center;
        font-family: ${fontFamily.neutral};
        font-size: 14px;
        line-height: 21px;
    }

    p {
        color: ${colorNeutralDark['90']};
        align-self: ${({ alinhamento }) =>
            alinhamento === 'Centro'
                ? `center`
                : alinhamento === 'Fim'
                ? `end`
                : `start`};
        text-align: ${({ alinhamento }) =>
            alinhamento === 'Centro'
                ? `center`
                : alinhamento === 'Fim'
                ? `end`
                : `start`};
    }
    h2 {
        font-family: ${fontFamily.brand};
        font-size: 24px;
        line-height: 26px;
        font-weight: normal;
        padding-bottom: 13px;
        align-self: ${({ alinhamento }) =>
            alinhamento === 'Centro'
                ? `center`
                : alinhamento === 'Fim'
                ? `end`
                : `start`};
        text-align: ${({ alinhamento }) =>
            alinhamento === 'Centro'
                ? `center`
                : alinhamento === 'Fim'
                ? `end`
                : `start`};
    }

    ${media.phone`
        font-size: 14px;
        line-height: 21px;
        h2{
            font-size: 20px;
            padding-bottom: 5px;
        }
    `}
`
